import React from "react";
import SidebarSection, { SidebarSectionProps } from "./SideBarSection";
import { getMenuItemUrl } from "./menuItems";

interface SidebarListItemProps extends SidebarSectionProps {
  isNavOpen: boolean;
}

const SidebarListItem = React.memo<SidebarListItemProps>(
  function SidebarListItem(props) {
    return (
      <li className="side_nav_parent-li" onClick={e => e.stopPropagation()}>
        <SidebarSection item={props.item} hasSubMenu={props.hasSubMenu} />
        {"children" in props.item && (
          <ul
            role="menu"
            className={`side_nav_child-ul${
              props.isNavOpen ? "" : " collapsed"
            }`}
          >
            {props.item.children.map(child => (
              <SidebarListItem
                key={`${child.label}-${getMenuItemUrl(child)}`}
                item={child}
                hasSubMenu={false}
                isNavOpen={props.isNavOpen}
              />
            ))}
          </ul>
        )}
      </li>
    );
  }
);

export default SidebarListItem;
